<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content [innerHTML]="data.html"></mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="close()">{{ data.dialog_close_button }}</button>
</mat-dialog-actions>
